import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import { includes } from 'lodash'
import Modal from 'react-modal'
import {Row, Col} from 'react-flexbox-grid'
import ReactTooltip from 'react-tooltip'
import config from '../../config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './CompanyProfileModal.css'

@CSSModules(Styles)
export default class CompanyProfileModal extends Component {
  static propTypes = {
    holding: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props);
    console.log(props.holding)
    this.state = {
      modalOpen: false
    }
  }

  openModal = () =>{
    this.setState({ modalOpen: true })
  }

  closeModal = () =>{
    this.setState({ modalOpen: false })
  }
  //
  render() {
    const h = this.props.holding
    let company_sources = config.wffCompanySources[h.company_id]

    if (!company_sources) {
      return <span>{this.props.children}</span>
    }

    const standard_name = company_sources[0]
    company_sources = company_sources.slice(1)

    const iconNw = require( '../../../static/images/icn-nw-no-circle-white.svg' )
    const iconCm = require( '../../../static/images/icn-cm-no-circle-white.svg' )

    return (
      <span>
        <span onClick={this.openModal} styleName='modal-opener'>
          {this.props.children}
        </span>

        <Modal
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          contentLabel="Company profile"
          style={{
            overlay : {
              backgroundColor   : 'rgba(0, 0, 0, 0.75)'
            },
            content: {
              position                   : 'absolute',
              left                       : 0,
              right                      : 0,
              marginLeft                 : 'auto',
              marginRight                : 'auto',
              borderRadius               : 0,
              width                      : '900px',
              maxWidth                   : '90%',
              top                        : '50%',
              border                     : '0px',
              background                 : '#fff',
              overflow                   : 'visible',
              bottom                     : 'auto',
              WebkitOverflowScrolling    : 'touch',
              outline                    : 'none',
              transform                  : 'translateY(-50%)',
              padding                    : 0,
              zIndex                     : 999
            }
          }}>
          <div styleName='family-modal-wrap'>
            <div styleName='family-modal'>
              <div styleName='family-modal-header-wrap'>
                <div styleName='family-modal-header'>
                  {standard_name}
                </div>
              </div>
              <p>
                <span style={{fontWeight: '800'}}>Source data:</span> Below is a list of pension funds and asset managers that list
                this company for exclusion on the basis of involvement with military weapons. Exclusions for nuclear weapons or controversial weapons are marked with an icon.
              </p>
              <div styleName='sources-ul'>
                { company_sources.map((e, i) => {
                  const source_idx = e[0]
                  const special_str = e.length > 1 ? e[1].split('') : null
                  const source_dat =  config.wffSources[source_idx]
                  const source_shortname = source_dat[0]
                  const source_desc = source_dat[1]
                  const source_name = source_dat[2]
                  let source_filename = source_dat[3]
                  if (source_filename.slice(-3) === 'pdf' ||
                      source_filename.slice(-4) === 'xlsx') {
                    source_filename = config.links.exclusionListsS3 + source_filename
                  }
                  return <div
                    key={'company-source-'+h.company_id+'-'+i}
                    styleName='source-li-wrap'
                  >
                    <div styleName='source-li'>
                      <div styleName='source-shortname'>
                        <div>
                          <div>
                            <b>{source_shortname}</b>
                            <span
                              style={{display:'inline-block', width:'30px;'}}
                              data-multiline
                              data-effect='solid'
                              data-tip={"<div style='max-width:150px;'>"+source_desc+'</div>'}
                              data-for={'source-tooltip-'+i}
                              data-place='top'
                              data-html
                            >
                              <LinkIcon faclass='fa-info-circle'/>
                            </span>
                          </div>
                          <div>
                            <Link
                              to={source_filename}
                              title={source_name}
                            >
                              {source_name}
                            </Link>
                          </div>
                        </div>
                        <div>
                          {
                            special_str && special_str.includes('n') ?
                              <img
                                styleName='detail-icon-holding'
                                src={iconNw}
                                alt='Nuclear weapons'
                                data-multiline
                                data-effect='solid'
                                data-tip="<div style='max-width:150px;'>Flagged for nuclear weapons</div>"
                                data-for={'source-icon1-'+i}
                                data-place='left'
                                data-html

                              /> : null
                          }
                          {
                            special_str && special_str.includes('c') ?
                              <img
                                styleName='detail-icon-holding'
                                src={iconCm}
                                alt='Controversial weapons'
                                data-multiline
                                data-effect='solid'
                                data-tip="<div style='max-width:150px;'>Flagged for controversial weapons</div>"
                                data-for={'source-icon2-'+i}
                                data-place='left'
                                data-html
                              /> : null
                          }
                        </div>
                      </div>
                      <ReactTooltip id={'source-tooltip-'+i}/>
                      <ReactTooltip id={'source-icon1-'+i}/>
                      <ReactTooltip id={'source-icon2-'+i}/>

                    </div>
                  </div>
                }) }
              </div>
            </div>
            <div
              styleName='family-modal-close-wrap'
              onClick={ this.closeModal }
            >
              <div
                styleName='family-modal-close'
                className='fa fa-times'
              />
            </div>
          </div>
        </Modal>
      </span>
    )
  }
}

